import { css } from 'styled-components';
import { getSpacing } from '../../theme';
export const base = _ref => {
  let {
    theme,
    $margin,
    $padding
  } = _ref;
  return css(["", " ", ""], getSpacing.margin(theme, $margin), getSpacing.padding(theme, $padding));
};
//# sourceMappingURL=Spacing.style.js.map